import Link from "next/link";
import { useState } from "react";
import dynamic from "next/dynamic";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";

// Lazy-load the enquiry modal from inside the QuickView modal — only
// ever mounted when the user clicks the QuickView "Send Enquiry" CTA.
const SendEnquiryButton = dynamic(
  () => import("@/components/enquiry/SendEnquiryButton"),
  { ssr: false }
);
import {
  addToWishlist,
  deleteFromWishlist,
} from "@/store/slices/wishlist-slice";
import { addToCompare, deleteFromCompare } from "@/store/slices/compare-slice";

import {
  FaRegHeart,
  FaExchangeAlt,
  FaInstagram,
  FaDribbble,
  FaTwitter,
  FaFacebookF,
} from "react-icons/fa";
import ProductRating from "../product/ProductRating";

const QuickViewModal = ({
  productData,
  onHide,
  show,
  slug,
  discountedprice,
  productprice,
  wishlistitem,
  compareitem,
}) => {
  const modalClose = () => {
    onHide();
  };

  const dispatch = useDispatch();

  const [selectedProductColor, setSelectedProductColor] = useState(
    productData.variation ? productData.variation[0].color : ""
  );
  const [selectedProductSize, setSelectedProductSize] = useState(
    productData.variation ? productData.variation[0].size[0].name : ""
  );
  const [productStock, setProductStock] = useState(
    productData.variation
      ? productData.variation[0].size[0].stock
      : productData.stock
  );
  const [quantityCount, setQuantityCount] = useState(1);

  return (
    <Modal
      show={show}
      onHide={modalClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      className="ltn__modal-area ltn__quick-view-modal-area"
    >
      <Modal.Header>
        <Button className="close" variant="secondary" onClick={modalClose}>
          <span aria-hidden="true">&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="ltn__quick-view-modal-inner">
          <div className="modal-product-item">
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="modal-product-img">
                  <img src="/img/product/4.webp" alt="#" />
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="modal-product-info">
                  <h3>
                    <Link onClick={modalClose} href={`/projects/${slug}`}>
                      {productData.title}
                    </Link>
                  </h3>
                  <div className="product-price d-none">
                    <div>
                      <span>${discountedprice}</span>
                      <del>{productprice}</del>
                      <span className="on-sale">
                        {productData.discount} % Off
                      </span>
                    </div>
                    {productData.rating && productData.rating > 0 ? (
                      <div className="product-quickview__rating-wrap">
                        <div className="product-quickview__rating">
                          <ProductRating ratingValue={productData.rating} />
                          <span>({productData.ratingCount})</span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <hr />
                
                  <div className="modal-product-brief">
                    <p>{productData.description.shortDescription}</p>
                  </div>

                  <div className="ltn__product-details-menu-3">
                    <ul>
                      <li>
                        <SendEnquiryButton
                          product={productData}
                          label="Send Enquiry"
                        />
                      </li>
                      <li>
                        <button
                          className="btn-addtocart"
                          onClick={
                            wishlistitem !== undefined
                              ? () =>
                                  dispatch(deleteFromWishlist(productData.id))
                              : () => dispatch(addToWishlist(productData))
                          }
                        >
                          <FaRegHeart />
                        </button>
                      </li>
                      <li>
                        <button
                          className="btn-addtocart"
                          onClick={
                            compareitem !== undefined
                              ? () =>
                                  dispatch(deleteFromCompare(productData.id))
                              : () => dispatch(addToCompare(productData))
                          }
                        >
                          <FaExchangeAlt />
                        </button>
                      </li>
                    </ul>
                  </div>
                  <hr />
                  <div className="ltn__social-media">
                    <ul>
                      <li>Share:</li>
                      <li>
                        <Link href="#" title="Facebook">
                          <FaFacebookF />
                        </Link>
                      </li>
                      <li>
                        <Link href="#" title="Twitter">
                          <FaTwitter />
                        </Link>
                      </li>
                      <li>
                        <Link href="#" title="Linkedin">
                          <FaDribbble />
                        </Link>
                      </li>
                      <li>
                        <Link href="#" title="Instagram">
                          <FaInstagram />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <label className="float-end mb-0">
                    <Link
                      onClick={modalClose}
                      className="text-decoration"
                      href={`/projects/${slug}`}
                    >
                      <small>View Details</small>
                    </Link>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default QuickViewModal;
